'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$tag = _ref.tag,
      defaultTag = _ref$tag === undefined ? 'div' : _ref$tag,
      _ref$prop = _ref.prop,
      prop = _ref$prop === undefined ? 'tag' : _ref$prop,
      _ref$propsToOmit = _ref.propsToOmit,
      propsToOmit = _ref$propsToOmit === undefined ? [] : _ref$propsToOmit;

  return function (_ref2) {
    var children = _ref2.children,
        otherProps = _objectWithoutProperties(_ref2, ['children']);

    var tag = otherProps[prop] || defaultTag;
    var omitPropsKeys = [prop].concat(_toConsumableArray(propsToOmit));
    var props = (0, _pickBy2.default)(otherProps, function (value, key) {
      return omitPropsKeys.indexOf(key) === -1;
    });

    return _react2.default.createElement(tag, props, children);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-create-component-from-tag-prop/dist/index.js
// module id = 457
// module chunks = 95715928098905 168707334958949